import { render, staticRenderFns } from "./activityRecord.vue?vue&type=template&id=a3601cf8&scoped=true"
import script from "./activityRecord.vue?vue&type=script&lang=js"
export * from "./activityRecord.vue?vue&type=script&lang=js"
import style0 from "./activityRecord.vue?vue&type=style&index=0&id=a3601cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_30effc9705e4bf7ead9172d765b7e483/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3601cf8",
  null
  
)

export default component.exports